import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import useRolePermissions from 'hooks/useRolePermissions'
import { summarizeViewers } from 'utils/presenceUtils'

// Who else (teammates, or this account in another session) currently has the patient open.
// Returns null when there is nothing to show, including for users without the hiPresence permission.
const usePatientPresence = patientId => {
  const { permissions } = useRolePermissions()
  const viewers = useSelector(state => Object.values(state.presenceReducer.byPatientId[patientId] || {}), shallowEqual)

  return useMemo(() => {
    if (!permissions.hiPresence || !viewers.length) {
      return null
    }

    const summary = summarizeViewers(viewers)
    return summary.primary ? summary : null
  }, [permissions.hiPresence, viewers])
}

export default usePatientPresence
